export function prefersReducedMotion(windowRef = globalThis.window) {
    if (typeof windowRef?.matchMedia !== 'function') {
        return false;
    }

    return windowRef.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function supportsAnimationFinished() {
    return typeof globalThis.Animation === 'function'
        && typeof globalThis.Animation.prototype === 'object'
        && globalThis.Animation.prototype !== null
        && 'finished' in globalThis.Animation.prototype;
}

export function canAnimateElement(element, windowRef = globalThis.window) {
    return element instanceof HTMLElement
        && typeof element.animate === 'function'
        && supportsAnimationFinished()
        && prefersReducedMotion(windowRef) === false;
}

export function parseCssTimeMs(rawValue) {
    const normalizedValue = String(rawValue ?? '').trim();
    if (normalizedValue === '') {
        return 0;
    }

    if (normalizedValue.endsWith('ms')) {
        const parsedMs = Number.parseFloat(normalizedValue.slice(0, -2));
        return Number.isFinite(parsedMs) ? parsedMs : 0;
    }

    if (normalizedValue.endsWith('s')) {
        const parsedSeconds = Number.parseFloat(normalizedValue.slice(0, -1));
        return Number.isFinite(parsedSeconds) ? parsedSeconds * 1000 : 0;
    }

    const parsedNumber = Number.parseFloat(normalizedValue);
    return Number.isFinite(parsedNumber) ? parsedNumber : 0;
}

export function readCssTimeMs(element, propertyName, fallbackMs = 0) {
    if (!(element instanceof HTMLElement) || typeof globalThis.getComputedStyle !== 'function') {
        return fallbackMs;
    }

    const styles = globalThis.getComputedStyle(element);
    if (styles === null || typeof styles !== 'object') {
        return fallbackMs;
    }

    const parsedValue = parseCssTimeMs(styles.getPropertyValue(propertyName));
    return parsedValue > 0 ? parsedValue : fallbackMs;
}
